import { useAuth } from "../../providers/auth";
import { useEffect } from "react";
import { postEvent } from "../../helpers/postEvent";
import { AlertCircle } from "lucide-react";
import { config } from "config";

export const IntegrationErrorView = ({
  errorMessage
}: {
  errorMessage?: string;
}) => {
  const { error: _error } = useAuth();
  const error = errorMessage || _error;

  useEffect(() => {
    postEvent({
      type: "analytics",
      action: "pageview",
      source: "/integration-error",
      message: error || "Unknown error"
    });
  }, []);

  return (
    <div className="max-w-md mx-auto w-full px-4 py-8 flex flex-col gap-4">
      <div className="mt-16 rotate-180 flex justify-center">
        <AlertCircle size="64" className="text-danger-500" />
      </div>
      <h1 className="text-center text-xl font-bold text-content-1000">
        Integration error
      </h1>

      <p className="text-center text-sm text-content-400 font-medium">
        {error ||
          "Oops, seems like something went wrong. Please try again later"}
      </p>

      {config.appEnv === "staging" ? (
        <div className="bg-alpha-10 p-4 rounded flex flex-col gap-2">
          <p className="text-sm text-content-400 font-medium">
            <strong>Debug Info:</strong>
          </p>
          <pre className="bg-alpha-20 p-2 rounded text-xs text-content-300">
            {config.buildId
              ? `Build ID: ${config.buildId}\n`
              : "Build ID: Not available\n"}
          </pre>

          <button
            className="mt-2 text-sm text-content-1000 font-medium underline"
            onClick={() => {
              throw new Error(
                "This is a raw error triggered from the IntegrationErrorView for testing purposes."
              );
            }}
          >
            Test raw error
          </button>
          <button
            className="mt-2 text-sm text-content-1000 font-medium underline"
            onClick={() => {
              const undefinedVar = undefined;
              // @ts-expect-error - Testing purposes
              console.log(undefinedVar.props);
            }}
          >
            Test cannot read props of undefined
          </button>
        </div>
      ) : null}

      {config.appEnv === "sandbox" ? (
        <div className="bg-alpha-10 p-4 rounded border border-alpha-20 flex flex-col gap-3">
          <h2 className="text-center text-lg font-semibold text-content-1000">
            Sandbox Environment
          </h2>

          <p className="text-sm text-content-400">
            <strong>User Agent:</strong> {navigator.userAgent}
          </p>

          <p className="text-sm text-content-400">
            <strong>iOS Platform Pay Supported:</strong>{" "}
            {/iPad|iPhone|iPod/.test(navigator.userAgent) ? "Yes" : "No"}
          </p>
        </div>
      ) : null}

      {config.appEnv === "production" &&
      new URLSearchParams(window.location.search).has("boom_debug_status") ? (
        <div className="bg-alpha-10 p-4 rounded border border-alpha-20 flex flex-col gap-3">
          <button
            className="mt-2 text-sm text-content-1000 font-medium underline"
            onClick={() => {
              throw new Error(
                "This is a raw error triggered from the IntegrationErrorView for testing purposes."
              );
            }}
          >
            Test raw error
          </button>
          <button
            className="mt-2 text-sm text-content-1000 font-medium underline"
            onClick={() => {
              const undefinedVar = undefined;
              // @ts-expect-error - Testing purposes
              console.log(undefinedVar.props);
            }}
          >
            Test cannot read props of undefined
          </button>
        </div>
      ) : null}
    </div>
  );
};
